module.exports = __webpack_public_path__ + "static/img/far3.a21e9268.png";